import type { IAssignmentRepository } from '@/core/domain/school/assignment/IAssignmentRepository'
import { ClassroomAssignedModule } from '@/core/domain/school/assignment/ClassroomAssignedModule.ts'

/**
 * Use case pour rendre visible un module donné pour l'élève
 */
export class SetModuleVisibilityUseCase {
  private readonly assignmentRepository: IAssignmentRepository

  constructor(assignmentRepository: IAssignmentRepository) {
    this.assignmentRepository = assignmentRepository
  }

  async execute(
    schoolId: number,
    periodId: number,
    assignmentId: number,
    moduleId: number,
    classroomId: number
  ): Promise<ClassroomAssignedModule> {
    return await this.assignmentRepository.setModuleVisibility(
      schoolId,
      periodId,
      assignmentId,
      moduleId,
      classroomId
    )
  }
}
